import React from "react";
import './faqs-component.scss';
import { Collapse } from "antd";
import { t } from "i18next";

const FAQcomponent = ({ faqData }) => {
  console.log(faqData);

  return (
    <div className="FAQ-wrapper">
      {faqData && faqData?.map((item, index) => {
        return (
          <div className="collapse-wrapper" key={item?.sequence}>
            <span className="collapse-title">{item?.originalSection}</span>
            <Collapse bordered={false} defaultActiveKey={['']}>
              {item?.faqs?.map((question, qIndex) => {
                return (
                  <Collapse.Panel 
                    header={question?.question} 
                    key={qIndex}
                  >
                    <p>{question?.answer}</p>
                  </Collapse.Panel>
                );
              })}
            </Collapse>
          </div>
        );
      })}
    </div>
  );
};

export default FAQcomponent;
